import { render, staticRenderFns } from "./envios_netsuite.vue?vue&type=template&id=b0114272"
import script from "./envios_netsuite.vue?vue&type=script&lang=js"
export * from "./envios_netsuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports